module.exports = __webpack_public_path__ + "img/qiu.50ca6408.svg";